<template>
  <div class="profile-section">
    <section class="toolbar">
      <div class="toolbar-container">
        <router-link id="back-button-profile" v-bind:to="'/operator/home-page'"><img src="/static/images/back.png"></router-link>
        <h1>Profile</h1>
      </div>
    </section>

    <div class="clearfix"></div>

    <div class="col-md-12">
      <div class="widget-wrap">
        <div class="tab-container col-md-12 custom-padding0" style="margin-top:20px">
          <form class="form-inline " id="operator_profile_form">
            <div class="group">
              <input type="text" id="fname" name="fname" v-model="fname">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="fname">First Name:</label>
            </div>
            <div class="group">
              <input type="text" id="lname" name="lname" v-model="lname">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="lname">Last Name:</label>
            </div>
            <div class="group groupbottom0">
              <input type="text" id="dot" name="dot" v-model="dot">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="dot">DOT:</label>
            </div>
            <div class="group no-dot">
              <input type="checkbox" id="no-dot" name="no_dot" v-model="no_dot" @change="noDotClicked()">
              <label for="dot">Don't have DOT number</label>
              
            </div>
            <div class="group">
              <input type="text" id="cdl" name="cdl" v-model="cdl">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="cdl">CDL:</label>
            </div>

            <div class="group">
              <div class="select-style">
                <select name="time_zone" v-model="selectedtimezone" id="time_zone" class="form-control">
                  <option :id="'time-zone-'+index" v-for="(option, index) in options" :value="option.time_zone+'||'+option.Offset+'||'+option.Initial">
                    {{ option.name }}
                  </option>
                </select>
              </div>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="time_zone">Time Zone:</label>
            </div>

            <div class="group">
              <div class="select-style">
                <select name="date_format" v-model="dateformat" id="date_format" class="form-control">
                  <option id="date-format-0" value="01-02-2006">01-31-2016</option>
                  <option id="date-format-1" value="2006-01-02">2016-01-31</option>
                  <option id="date-format-2" value="02-01-2006">31-01-2016</option>
                  <option id="date-format-3" value="Jan 02, 2006">Jan 02, 2006</option>
                  <!-- <option id="date-format-4" value="2nd Jan, 2006 | 15:04:05">2nd Jan, 2006 | 15:04:05</option> -->
                </select>
              </div>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="date_format">Date Format:</label>
            </div>

            <button id="update-profile" type="button" class="btn btn-primary" v-on:click="updateProfile()">Update</button>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "profile",
  data: () => ({
    fname: "",
    lname: "",
    cdl: "",
    dot: "",
    no_dot: false,
    selectedtimezone: '',
    options: [],
    dateformat: "01-31-2016",
    old_dot:"",
  }),
  mounted: function() {
    this.call();
  },
  methods: {

    noDotClicked: function() {
      var self = this;
      console.log(self.no_dot);
      if(self.no_dot) {
        self.dot ="2183122";
        $("#dot").attr('readonly', true);
      } else {
        self.dot =self.old_dot;
        $("#dot").attr('readonly', false);
      }
    },
    updateProfile: function() {

      var self = this
      var data = $("#operator_profile_form").serialize();
      
      self.$config.loading=true;
      $.ajax({
        url: self.$config.API + '/v1/operator/profile',
        type: "POST",
        data: data,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },timeout: 10000,
        success: function(data) {self.$config.loading=false;

          if (data.status == "success") {
            alert("Profile has been updated successfully.")
          } else {
            alert("There is some error occurred")
          }

        },
        error: function(jqXHR, exception, textstatus) {self.$config.loading=false;
          //if session expired
          if(textstatus==="timeout") {
            alert("Request timeout");
        } else if (jqXHR.responseJSON.code == 401) {
            self.$router.push(
              "/v1/operator/login"
            )
          } else if (jqXHR.responseJSON.code == 400) {
            alert(jqXHR.responseJSON.message);
          }

        }
      });
    },

    call: function() {

      var self = this;
      self.$config.loading=false;
      $.ajax({
        url: self.$config.API + '/v1/operator/profile',
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },timeout: 10000,
        success: function(data) {self.$config.loading=false;
          console.log(data);
          var data1 = data.data

          if (data.status == "success") {
            if (data1.profile.length > 0) {
              $("#operator_name").text(data1.profile[0].fname + " " + data1.profile[0].lname)
              self.fname = data1.profile[0].fname
              self.lname = data1.profile[0].lname
              self.dot = data1.profile[0].dot
              self.old_dot = data1.profile[0].dot
              self.cdl = data1.profile[0].cdl
              self.dateformat = data1.profile[0].date_format
            }         

            //populate timezone select box
            if (data1.timezones.length > 0) {
              for (var i = 0; i < data1.timezones.length; i++) {
                self.options = data1.timezones
              }
            }
            if (data1.profile[0].time_zone != '') {
              self.selectedtimezone = data1.profile[0].time_zone
            } else {
              self.selectedtimezone = "PST8PDT||-0800||PST"
            }


          } else {
            alert("There is some error occurred, try again later")
          }

        },
        error: function(jqXHR, exception, textstatus) {self.$config.loading=false;
          //if session expired
          if(textstatus==="timeout") {
            alert("Request timeout");
        } else if (jqXHR.responseJSON.code == 401) {
            self.$router.push(
              "/v1/operator/login"
            )
          }

        }
      });

    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/profile.vue